// eslint-disable-next-line import/no-unresolved
import "swiper/css";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/navigation";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/free-mode";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/thumbs";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/grid";

import clsx from "clsx";
import Link from "next/link";
import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";

import styles from "./index.module.scss";

export default function BreadcrumbsMobile() {
  const { breadcrumbs }: any = useSelector((state: any) => state.breadcrumbs);

  return (
    <nav>
      <ol
        className={clsx(styles.Breadcrumbs)}
        itemScope
        itemType="http://schema.org/BreadcrumbList"
      >
        <Swiper
          slidesPerView="auto"
          spaceBetween={10}
          pagination={{
            clickable: true,
          }}
          className="swiper-auto-width"
        >
          {breadcrumbs.map((item: any, key: any) => (
            <SwiperSlide key={`${item.name}`}>
              {key === breadcrumbs.length - 1 ? (
                <li>
                  <span>{item.name}</span>
                </li>
              ) : (
                <li
                  itemProp="itemListElement"
                  itemScope
                  itemType="http://schema.org/ListItem"
                >
                  <Link href={item.link}>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a title={item.name} itemProp="item">
                      <span itemProp="name">{item.name}</span>
                      <span className={styles.Line} />
                    </a>
                  </Link>
                  <meta itemProp="position" content={key + 1} />
                </li>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </ol>
    </nav>
  );
}
